import './global.js';
import '@fengyuanchen/datepicker/dist/datepicker.min.css';
import $ from 'jquery';
import vanillaTextMask from 'vanilla-text-mask';
import './includes/dropDown';

const datepicker  = require('@fengyuanchen/datepicker/dist/datepicker.esm.js');
const lang = require('@fengyuanchen/datepicker/i18n/datepicker.ru-RU');
import { v$ } from './includes/helpers.js';
import handlePopup,{openPopup} from './includes/popupForm.js';


//Elements
const target =  v$('input[data-birthday]')[0];
const popupLink = v$('a[href$="#openPopup"]')[0];

if(location.hash === '#openPopup'){
    openPopup(v$('#register')[0]);
}
//Date

const startDate = `${new Date().getDate() - 1}/${new Date().getMonth() + 1}/` + (new Date().getFullYear() - 100),
      endDate   = `${new Date().getDate() - 1}/${new Date().getMonth() + 1}/` + (new Date().getFullYear() - 16),
      startYear = (new Date().getFullYear() - 100),
      endYear   = (new Date().getFullYear() - 16);
$('[data-birthday]').datepicker({
    trigger:'.popup-row-item-date-triger',
    format:'dd-mm-yyyy',
    startDate:startDate,
    offset: -15,
    endDate:endDate,
    language:process.env.NODE_ENV === 'development' ? "ru-RU" : window.JSI18N.activeLanguage.locale
});

$('[data-birthday]').on('hide.datepicker',(e) => {
    const event = document.createEvent('Event');
    event.initEvent('blur', true, true);
    target.dispatchEvent(event);
});
const birthDateMask = [/\d/, /\d/, '-',/\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];
if(v$('.popup-row-item-date input')[0]){
    vanillaTextMask({
        inputElement: v$('.popup-row-item-date input')[0],
        mask: birthDateMask,
    });
}
handlePopup(v$('#register')[0],v$('.register_triger')[0]);

//Open pop-up on link click
popupLink.addEventListener('click', function(e) {
    e.preventDefault();
    openPopup(v$('#register')[0]);
});
